let PackagesItem = [
    {
        trackJunior: true,
        trackTitle: "Junior Track",
        trackSubtitle: true,
        trackPrice: "0",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1668440055348x612070831693234200',
    },
    {
        trackFull: true,
        trackTitle: "Recordings",
        trackSubtitle: true,
        trackPrice: "49",
        trackFullPrice: '299',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior and Senior Track access',
        trackLink: 'https://geekle.us/ticket/1694111071295x921592511318196200',
    },
    {
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackPrice: "239",
        trackFullPrice: '599',
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://buy.stripe.com/aEU5nV74Y3R576g14f',
        inverseColors: true,
    },
    {
        trackTitle: "GEEKLE TEAM-5 PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 3,
        trackPrice: "499",
        trackFullPrice: '1999',
        trackText: true,
        trackText1: "One Year Pass for 5 team members",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    },
    {
        trackTitle: "GEEKLE TEAM-10 PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 3,
        trackPrice: "799",
        trackFullPrice: '5999',
        trackText: true,
        trackText1: "One Year Pass for 10 team members",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1694110751248x285686019182297100',
        validDate: '9.06',
        inverseColors: true,
    },
];

export default PackagesItem;
